import {cloneElement, useEffect, useRef, useState} from "react";
import MenuIcon from 'mdi-react/MenuIcon';
import CloseIcon from 'mdi-react/CloseIcon';
import WeatherNightIcon from 'mdi-react/WeatherNightIcon';
import WeatherSunnyIcon from 'mdi-react/WeatherSunnyIcon';
import LogoutVariant from 'mdi-react/LogoutVariantIcon';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import FormatListBulletedType from 'mdi-react/FormatListBulletedIcon';
import SettingsIcon from 'mdi-react/SettingsIcon';
import { SideNav, SideNavContent, SideNavFooter, SideNavItem } from "./Navigation";
import { Modal } from "./Modals";
import { Button, ButtonRow, DangerButton } from "./Buttons";
import { config, storage } from "../../config/constants";
import { useHistory } from "react-router";
import {isFunction, isString, map} from "lodash";
import {SelectSheet, SelectSheetTab, SelectSheetTabLarge} from "./Tabs";
import DotsVerticalIcon from 'mdi-react/DotsVerticalIcon';
import InformationCircleOutlineIcon from "mdi-react/InformationCircleOutlineIcon";
import {KeyValueTable} from "./Tables";
import ReloadIcon from "mdi-react/ReloadIcon";
import ExternalLinkIcon from "mdi-react/ExternalLinkIcon";

const Header = props => {

    const currentYear = useRef(new Date().getUTCFullYear()).current;
    const history = useHistory();

    const sideNavFooterRef = useRef();

    const [styles, setStyles] = useState({});
    const [sideNavContentStyles, setSideNavContentStyles] = useState({});
    const [menuOpened, setMenuOpened] = useState(false);
    const [signOutModalOpen, setSignOutModalOpen] = useState(false);

    const [aboutOpen, setAboutOpen] = useState(false);
    const [optionsOpen, setOptionsOpen] = useState(false);

    const [colorTheme, setColorTheme] = useState(localStorage.getItem("theme"));

    const toggleMenu = () => {
        setMenuOpened(!menuOpened);
    }

    useEffect(() => {
        if (props.offline) {
            return;
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        localStorage.setItem("theme", colorTheme);
        document.getElementsByTagName("body")[0].className = "";
        document.getElementsByTagName("body")[0].classList.add(colorTheme);
    }, [colorTheme]);

    useEffect(() => {
        const tempStyles = {};
        if (props.background) {
            tempStyles.backgroundColor = props.background;
        }

        if (props.color) {
            tempStyles.color = props.color;
        }

        setStyles(tempStyles);
    }, [props]);

    useEffect(() => {
        let contentStyles = {
            marginBottom: sideNavFooterRef.current.offsetHeight + "px"
        }

        setSideNavContentStyles(contentStyles);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sideNavFooterRef.current]);

    const doChooseSave = () => {
        localStorage.removeItem(storage.SAVE_ID);

        history.push("/save");
    }

    const doOpenUserSettings = () => {
        window.location = config.OAUTH_URL + "/myaccount/settings";
    }

    const doSignOut = () => {
        localStorage.removeItem(storage.ACCESS_TOKEN);
        localStorage.removeItem(storage.ACCESS_TOKEN_EXPIRE_DATE);
        localStorage.removeItem(storage.SAVE_ID);

        history.push("/");
    }

    const renderOptions = () => {
        return map(props.options, (value, index) => {
            return (
                <SelectSheetTab text={value}
                    onClick={() => handleOptionClick(value)}
                    key={index}/>
            )
        })
    }

    const handleOptionClick = (value) => {
        if (isFunction(props.onOptionSelect)) {
            props.onOptionSelect.call(this, value);
            setOptionsOpen(false);
        }
    }

    const renderExtrasButton = () => {
        if (props.withExtrasButton === true) {
            if (props.extrasButtonIcon !== undefined && props.extrasButtonIcon !== null) {
                return cloneElement(props.extrasButtonIcon, {
                    ...props.extrasButtonIcon.props,
                    onClick: () => handleExtraButtonClick(),
                    color: styles.color
                }, props.extrasButtonIcon.props.children);
            } else {
                return (
                    <DotsVerticalIcon onClick={() => handleExtraButtonClick()}
                                  color={styles.color}/>
                )
            }
        } else {
            return [];
        }
    }

    const handleExtraButtonClick = () => {
        if (isFunction(props.onExtraButtonClick)) {
            props.onExtraButtonClick.call(this);
        }
    }

    const toggleColorTheme = () => {
        if (colorTheme === "light") {
            setColorTheme("dark");
        } else {
            setColorTheme("light");
        }
    }

    return (
        <>
            <div className="header"
                style={{ ...styles }}>
                <div className="icon">
                    {(!props.offline) ?
                        (menuOpened) ?
                            <CloseIcon color={styles.color} onClick={toggleMenu} className={"menu-icon"} />
                            :
                            <MenuIcon color={styles.color} onClick={toggleMenu} className={"menu-icon"} />
                        :
                        null
                    }
                </div>
                
                <div className="title">
                    {!props.options && isString(props.title) &&
                        <p>{props.title}</p>
                    }

                    {!props.options && !isString(props.title) &&
                        props.title
                    }

                    {props.options &&
                        <div className="options-header-text">
                            <p className={(props.options) ? "with-options" : ""}>{props.title}</p>
                            <p className="options-select"
                                onClick={() => setOptionsOpen(true)}>
                                {props.optionsLabel}
                                <ChevronDownIcon/>
                            </p>
                        </div>
                    }
                </div>

                <div className="icon">
                    {
                        renderExtrasButton()
                    }
                </div>
                
            </div>
            <div className="header-spacing"></div>
            <SideNav isOpen={menuOpened} onDismiss={() => setMenuOpened(false)}>
                <SideNavContent style={sideNavContentStyles}>

                </SideNavContent>
                <SideNavFooter ref={sideNavFooterRef}>
                    <SideNavItem onClick={toggleColorTheme}>
                        {
                            (colorTheme === "dark") ?
                                <>
                                    <WeatherSunnyIcon/>
                                    <p>Light mode</p>
                                </>
                                :
                                <>
                                    <WeatherNightIcon/>
                                    <p>Dark mode</p>
                                </>
                        }
                    </SideNavItem>
                    <SideNavItem onClick={doChooseSave}>
                        <FormatListBulletedType />
                        <p>Choose save</p>
                    </SideNavItem>
                    <SideNavItem onClick={doOpenUserSettings}>
                        <SettingsIcon />
                        <p>Account settings</p>
                    </SideNavItem>
                    <SideNavItem onClick={() => setAboutOpen(true)}>
                        <InformationCircleOutlineIcon />
                        <p>About</p>
                    </SideNavItem>
                    <SideNavItem onClick={() => setSignOutModalOpen(true)}>
                        <LogoutVariant />
                        <p>Sign out</p>
                    </SideNavItem>
                </SideNavFooter>
            </SideNav>

            <Modal isOpen={signOutModalOpen}
                onDismiss={() => setSignOutModalOpen(false)}>
                <h3>Sign out</h3>
                <p>You are about to sign out. Are you sure?</p>
                <ButtonRow>
                    <DangerButton onClick={doSignOut}>
                        Sign out
                        </DangerButton>
                    <Button onClick={() => setSignOutModalOpen(false)}>
                        Cancel
                        </Button>
                </ButtonRow>
            </Modal>

            <SelectSheet classNames={"about-sheet"} isOpen={aboutOpen} onDismiss={() => setAboutOpen(false)} title={"About"}>
                <KeyValueTable values={[
                    {
                        name: "Copyright",
                        value: `MyScores By Sweejee\nCopyright (c) 2016 - ${currentYear}`
                    },
                    {
                        name: "Version",
                        value: localStorage.getItem(storage.VERSION)
                    }
                ]} />
                <SelectSheetTab onClick={() => window.location.reload()} text={"Reload app"} icon={<ReloadIcon/>}/>
                <SelectSheetTab onClick={() => window.location = "https://www.flaticon.com/packs/countrys-flags"} text={`Country icons created by Freepik - Flaticon`} icon={<ExternalLinkIcon/>}/>
            </SelectSheet>

            {props.options &&
                <SelectSheet isOpen={optionsOpen}
                    onDismiss={() => setOptionsOpen(false)}
                    title={props.optionsTitle}>
                    { renderOptions() }
                </SelectSheet>
            }
        </>
    )
}

export default Header;